import Drawer from '@material-ui/core/Drawer';
import React, {useState} from 'react';

import {useHandleScroll} from '../../../../pages/HomePage/HomePageSidebar/useHandleScroll';
import {CollectionInfo} from '../../../ModelRegistry/utils';
import {ResizableDrawer} from '../ResizableDrawer';
import {CreateRegisteredCollectionDrawerInner} from './CreateRegisteredCollectionDrawerInner';
import * as S from './CreateRegisteredCollectionDrawerInner.styles';

/**
 * Hierarchy of components:
 * CreateRegisteredCollectionDrawer - thin wrapper to allow animated drawer transition without loading content
 * CreateRegisteredCollectionDrawerInner - queries for data, shows loading indicator
 * * Individual drawer pages based on functions
 * * * DrawerPageCollectionConfiguration (Add name, description and tags for collection)
 * * * DrawerPageAddVersion (Select artifact version and aliases)
 */

type CreateRegisteredCollectionDrawerProps = {
  open: boolean;
  closeDrawer: () => void;

  registryEntityName?: string;
  defaultProjectName: string;
  artifactTypeName?: string;
  existingCollections?: CollectionInfo[];
  registryAllowsAllArtifactTypes?: boolean;
  refetchCollections?: () => void;
};

export const CreateRegisteredCollectionDrawer = ({
  open,
  closeDrawer,
  registryEntityName,
  defaultProjectName,
  artifactTypeName,
  existingCollections,
  registryAllowsAllArtifactTypes,
  refetchCollections,
}: CreateRegisteredCollectionDrawerProps) => {
  const [width, setWidth] = useState(600); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  const scrolled = useHandleScroll();
  return (
    <Drawer anchor="right" open={open} onClose={closeDrawer}>
      <ResizableDrawer
        startWidth={width}
        minWidth={600}
        onSetWidth={onSetWidth}>
        <S.DrawerContents scrollWidth={scrolled.scrollHeight}>
          <CreateRegisteredCollectionDrawerInner
            onClose={closeDrawer}
            registryEntityName={registryEntityName}
            artifactTypeName={artifactTypeName}
            defaultProjectName={defaultProjectName}
            existingCollections={existingCollections}
            registryAllowsAllArtifactTypes={registryAllowsAllArtifactTypes}
            refetchCollections={refetchCollections}
          />
        </S.DrawerContents>
      </ResizableDrawer>
    </Drawer>
  );
};
